import { __rest } from "tslib";
import React, { useRef } from "react";
import { useBlurAnimation } from "../../shared/animation";
import { useFocusTrap, useLockBodyScroll } from "../../shared/hooks";
import { Close } from "../Icons/Close";
import * as S from "./styles";
export function Modal(e) {
  var l = e.open,
      o = e.openHandler,
      t = e.children,
      _e$persist = e.persist,
      r = _e$persist === void 0 ? !1 : _e$persist,
      _e$overlayClose = e.overlayClose,
      a = _e$overlayClose === void 0 ? !0 : _e$overlayClose,
      n = __rest(e, ["open", "openHandler", "children", "persist", "overlayClose"]);

  var s = useRef(),
      c = useBlurAnimation(l);
  return useFocusTrap(s, l), useLockBodyScroll(), l ? React.createElement(React.Fragment, null, c(function (e, l) {
    return l && React.createElement(S.Overlay, {
      onClick: function onClick() {
        a && o(!1);
      },
      style: e
    });
  }), r || l ? React.createElement(S.Modal, Object.assign({
    ref: s,
    role: "dialog",
    style: {
      display: l ? "flex" : "none"
    }
  }, n), React.createElement(S.CloseButton, {
    "aria-label": "Close",
    onClick: function onClick() {
      return o(!1);
    }
  }, React.createElement(Close, null)), React.createElement(S.ModalContent, null, t), React.createElement(S.Gradient, null)) : null) : null;
}
export default Modal;